export default "__VITE_ASSET__tzRlsAYs__"